module.exports = __webpack_public_path__ + "img/burger.c04631a7.svg";